import { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    // If returning from Google OAuth callback, AuthCallback will establish the session first
    if (window.location.hash?.includes("session_id=")) return;
    api.get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => setUser(null));
  }, []);

  const exchangeSession = async (sessionId) => {
    const { data } = await api.post("/auth/session", { session_id: sessionId });
    setUser(data);
    return data;
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.warn("Logout request failed (session cleared locally):", e?.message); }
    delete api.defaults.headers.common.Authorization;
    setUser(null);
  };

  const value = useMemo(() => ({ user, login, register, logout, exchangeSession }), [user]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
